export default {
  paginate(results, currentPage, perPage) {
    let start;
    if (currentPage > 0) {
      start = currentPage * perPage;
    } else {
      start = currentPage;
    }
    let end = start + perPage;
    return results.slice(start, end);
  },
  getPages(currentPage, pageCount, pageRange = 3, marginPages = 1) {
    let items = {};

    if (pageCount <= pageRange) {
      for (let index = 0; index < pageCount; index++) {
        let page = {
          index: index,
          content: index + 1,
          selected: index === currentPage
        };
        items[index] = page;
      }
      return items;
    }

    let leftPart = Math.ceil(pageRange / 2);

    let rightPart = pageRange - leftPart;

    if (currentPage < leftPart) {
      leftPart = currentPage;

      rightPart = pageRange - leftPart;
    } else if (currentPage > pageCount - pageRange / 2) {
      rightPart = pageCount - currentPage;

      leftPart = pageRange - rightPart;
    }

    let breakView = {
      content: "...",
      disabled: true
    };

    // items logic extracted into this function
    let mapItems = index => {
      let page = {
        index,
        content: index + 1,
        selected: index === currentPage
      };

      if (index <= marginPages - 1 || index >= pageCount - marginPages) {
        items[index] = page;

        return;
      }

      if (pageCount > pageRange * 2) {
        if (
          currentPage - leftPart > marginPages &&
          items[marginPages] !== breakView
        ) {
          items[marginPages] = breakView;
        }

        if (
          currentPage + rightPart < pageCount - marginPages - 1 &&
          items[pageCount - marginPages - 1] !== breakView
        ) {
          items[pageCount - marginPages - 1] = breakView;
        }
      }

      let overCount = currentPage + rightPart - pageCount + 1;

      if (overCount > 0 && index === currentPage - leftPart - overCount) {
        items[index] = page;
      }

      if (index >= currentPage - leftPart && index <= currentPage + rightPart) {
        items[index] = page;

        return;
      }
    };

    // 1st - loop thru low end of margin pages
    for (let i = 0; i < marginPages; i++) {
      mapItems(i);
    }

    // 2nd - loop thru high end of margin pages
    for (let i = pageCount - 1; i >= pageCount - marginPages; i--) {
      mapItems(i);
    }

    // 3rd - loop thru selected range
    let selectedRangeLow = 0;

    if (currentPage - pageRange > 0) {
      selectedRangeLow = currentPage - pageRange;
    }

    let selectedRangeHigh = pageCount;
    if (currentPage + pageRange < pageCount && pageCount > pageRange * 2) {
      selectedRangeHigh = currentPage + pageRange;
    }

    for (let i = selectedRangeLow; i < selectedRangeHigh; i++) {
      mapItems(i);
    }

    return items;
  }
};
